import { create } from 'zustand';
import { logger } from '../../../shared/utils/logger';
import { MapService } from '../services/map/mapService';

export interface ElementData {
  id: string;
  storeyId: string;
  category: string;
  area: number;
  finca: number | null;
  computo: number | null;
  nombre: string | null;
  geometry: any;
  feature: any;
}

interface ElementsState {
  elements: ElementData[];
  selectedElementId: string | null;
  mapService: MapService | null;
  
  // Actions
  setMapService: (mapService: MapService | null) => void;
  updateElements: () => void;
  setSelectedElement: (elementId: string | null) => void;
  updateElementProperty: (elementId: string, property: keyof ElementData, value: any) => void;
  getElementsByStorey: (storeyId: string) => ElementData[];
  getElementById: (elementId: string) => ElementData | undefined;
  clearElements: () => void;
}

export const useElementsStore = create<ElementsState>((set, get) => ({
  elements: [],
  selectedElementId: null,
  mapService: null,

  setMapService: (mapService: MapService | null) => {
    set({ mapService });
    if (mapService) {
      // Configurar listener para cambios en el mapa
      mapService.onElementsChanged = () => {
        get().updateElements();
      };
      
      // Inicializar elementos inmediatamente
      setTimeout(() => {
        get().updateElements();
      }, 100);
    }
  },

  updateElements: () => {
    const { mapService } = get();
    if (!mapService) return;

    try {
      const elementsData = mapService.getElementsData();
          set({ elements: elementsData });
    logger.log('ELEMENTS_STORE', '🔄 ElementsStore: Elementos actualizados:', elementsData.length);
    } catch (error) {
              logger.error('ELEMENTS_STORE', '❌ ElementsStore: Error al actualizar elementos:', error);
    }
  },

  setSelectedElement: (elementId: string | null) => {
    set({ selectedElementId: elementId });
  },

  updateElementProperty: (elementId: string, property: keyof ElementData, value: any) => {
    const { elements, mapService } = get();
    
    // Actualizar el elemento en el store
    const updatedElements = elements.map(element => 
      element.id === elementId ? { ...element, [property]: value } : element
    );
    set({ elements: updatedElements });

    // Actualizar la feature en el mapa si existe
    const element = elements.find(el => el.id === elementId);
    if (element?.feature && mapService) {
      element.feature.set(property, value);
      logger.log('ELEMENTS_STORE', `🔄 ElementsStore: Propiedad ${property} actualizada para elemento ${elementId}:`, value);
    }
  },

  getElementsByStorey: (storeyId: string) => {
    const { elements } = get();
    return elements.filter(element => element.storeyId === storeyId);
  },

  getElementById: (elementId: string) => {
    const { elements } = get();
    return elements.find(element => element.id === elementId);
  },

  clearElements: () => {
    set({ elements: [], selectedElementId: null });
  }
}));
